import './index.css'

function Holder({left,right}){
    return <div className="holder">
    {left}
    <div>
    {right}
    </div>
    </div>
}

export default Holder